import { Box } from '@mui/material'
import React from 'react'
import ConstructionIcon from '@mui/icons-material/Construction';

function Tickets() {
return (
    <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="60vh"
    >
        <Box
            sx={{
                fontSize: 32,
                fontWeight: 'bold',
                mb: 2,
                textAlign: 'center',
            }}
        >
            Page en cours de construction
        </Box>
        <Box color="text.secondary" textAlign="center">
            Cette page sera bientôt disponible.
        </Box>
    </Box>
)
}

export default Tickets